import api from './api';

export interface DashboardPosition {
  tradingSymbol: string; quantity: number; avgPrice: number; ltp: number | null; pnl: number | null;
}

export interface DashboardBrokerSummary {
  // null = genuinely not available from that broker's API (not a real computed zero) — e.g.
  // Groww exposes no unrealized P&L at all, a failed fetch has no real numbers to show.
  broker: string; connected: boolean; realizedPnl: number | null; unrealizedPnl: number | null; totalPnl: number | null;
  availableBalance: number | null; positions: DashboardPosition[]; error?: string;
}

export const dashboardAPI = {
  getPnlSummary: () => api.get<{ brokers: DashboardBrokerSummary[] }>('/dashboard/pnl-summary'),
};
